import React from 'react';
import { useAuthStore } from '../../../app/store/auth-store';

/**
 * Hook for authentication operations
 */
export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    checkAuth,
    refreshToken,
  } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    checkAuth,
    refreshToken,
  };
};

/**
 * Hook for permission checking
 */
export const usePermissions = () => {
  const { permissions, hasPermission, user } = useAuthStore();

  return {
    permissions,
    hasPermission,
    // Convenience methods for common permissions
    canReadUsers: hasPermission('users:read'),
    canWriteUsers: hasPermission('users:write'),
    canDeleteUsers: hasPermission('users:delete'),
    canReadRoles: hasPermission('roles:read'),
    canWriteRoles: hasPermission('roles:write'),
    canDeleteRoles: hasPermission('roles:delete'),
    canManageUsers: hasPermission('users:*'),
    canManageRoles: hasPermission('roles:*'),
    isSuperuser: user?.isSuperuser || false,
  };
};

/**
 * Hook that automatically checks authentication on mount
 */
export const useAuthCheck = () => {
  const { checkAuth, isLoading, isAuthenticated } = useAuth();

  // Check auth on mount
  React.useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return {
    isLoading,
    isAuthenticated,
  };
};